// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type GeneratedPartialPaymentFragment = { __typename?: 'GeneratedPartialPaymentDTO', amount: number, date: LocalDate, notes: string | null, paymentId: number | null, username: string | null };

export const GeneratedPartialPaymentFragment = gql`
    fragment GeneratedPartialPayment on GeneratedPartialPaymentDTO {
  amount
  date
  notes
  paymentId
  username
}
    `;
/* eslint-enable */